import type {Region} from '@/redux/v1/models';

import {useSelector} from 'react-redux';

import {getRegions} from '@/redux/v1/hotels/list/reducer';

export type Option = {
  label: {
    name: string;
    count: number;
    type: 'groupHeader' | 'normal' | 'reset';
  };
  value: string;
};

type Return = {data: Array<Option>; areRegionsNested: boolean};

export const useRegionSelectOptions = (): Return => {
  const regions = useSelector(getRegions);
  const areRegionsNested = regions.some(({children}) => children);

  // @ts-expect-error ...
  const reducer = (accumulator, {children = [], count, id, name}: Region) => {
    return [
      ...accumulator,
      {
        value: id,
        label: {
          name,
          count,
          type: children.length > 0 ? 'groupHeader' : 'normal',
        },
      },
      // eslint-disable-next-line unicorn/no-array-callback-reference -- I find the directive ridiculous
      ...children.reduce(reducer, []),
    ];
  };

  return {
    // eslint-disable-next-line unicorn/no-array-callback-reference -- Same here
    data: regions.reduce(reducer, []),
    areRegionsNested,
  };
};
